export const theme = (prefersDarkMode) => ({
  typography: {
    fontFamily: [
      'Raleway'
    ].join(','),
  },
  palette: {
    mode: prefersDarkMode ? 'dark' : 'light',
    primary: {
      main: '#E87721',
      light: '#f59528',
      dark: '#dd601d',
      contrastText: '#fff',
    },
    secondary: {
      main: '#2c2d2d',
      light: '#6E6E6F',
      dark: '#000',
      contrastText: '#fff',
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'capitalize',
          fontWeight: 800,
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: 32,
          height: 18,
          padding: 0,
          '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
              transform: 'translateX(14px)',
              color: '#fff',
              '& + .MuiSwitch-track': {
                backgroundColor: '#E87721',
                opacity: 1,
                border: 0,
              },
              '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
              },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
              color: '#dd601d',
              border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
              color: '#E9E9EA'
            },
            '&.Mui-disabled + .MuiSwitch-track': {
              opacity: 0.7,
            },
          },
          '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 14,
            height: 14,
          },
          '& .MuiSwitch-track': {
            borderRadius: 10,
            backgroundColor: '#888888',
            opacity: 1,
            transition: 'background-color 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
          },
        },
        sizeSmall: {
          width: 24,
          height: 14,
          '& .MuiSwitch-switchBase': {
            '&.Mui-checked': {
              transform: 'translateX(10px)',
            },
          },
          '& .MuiSwitch-thumb': {
            width: 10,
            height: 10,
          },
          '& .MuiSwitch-track': {
            borderRadius: 7,

          },
        },
        sizeBig: {
          width: 42,
          height: 26,
          '& .MuiSwitch-switchBase': {
            '&.Mui-checked': {
              transform: 'translateX(16px)',
            },
          },
          '& .MuiSwitch-thumb': {
            width: 22,
            height: 22,
          },
          '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
          },
        }
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'capitalize',
          fontWeight: 800,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& input': {
            padding: '8px 12px',
          },
          '& label': {
            transform: 'translate(14px, 10px) scale(1)',
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          '& .MuiSelect-select': {
            padding: '8px 34px 8px 12px',
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            padding: '0px 65px 0px 12px',
          },
        },
      },
    },
  },
})

export default theme
